import axios from 'axios';
import { uploadImageToFirebase } from '../../utils/firebaseStorage';

const API_URL = '/api/products/';

// --- Firebase Image Upload ---
const uploadImage = (imageFile) =>
    uploadImageToFirebase(imageFile, {
        folder: 'product_images',
    });

// --- API Functions ---
const addProduct = async (productData, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.post(API_URL, productData, config);
    return response.data;
};

const getProducts = async (market) => {
    const config = market
        ? { params: { market } }
        : undefined;
    const response = await axios.get(API_URL, config);
    return response.data;
};

const getAdminProducts = async (token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.get(API_URL + 'all', config);
    return response.data;
};

const getProductById = async (id) => {
    const response = await axios.get(API_URL + id);
    return response.data;
};

const deleteProduct = async (id, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.delete(API_URL + id, config);
    return response.data;
};

const restoreProduct = async (id, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.patch(`${API_URL}${id}/restore`, {}, config);
    return response.data;
};

const updateProduct = async (id, productData, token) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const response = await axios.put(API_URL + id, productData, config);
    return response.data;
};

const productService = {
    addProduct,
    uploadImage,
    getAdminProducts,
    getProductById,
    deleteProduct,
    restoreProduct,
    updateProduct,
    getProducts
};

export default productService;
